import {reqWithToken} from './requestHelper';

//crud

export async function insert(insert) {
    return (await reqWithToken('api/forms',{
        method: 'post',
        data: insert
    })).data;
}

export async function get(id) {
    return (await reqWithToken(`api/forms/${id}`,)).data;
}

export async function getAll() {
    return (await reqWithToken('api/forms')).data;
}

export async function update(update) {
    return (await reqWithToken('api/forms',{
        method: 'put',
        data: update
    })).data;
}

export async function remove(id) {
    return (await reqWithToken('api/forms/',{
        method: 'delete',
        params: {id}
    })).data;
}

export async function getFormActionByInfo(update) {
    return (await reqWithToken('api/forms/getFormActionByInfo',{
        method: 'put',
        data: update
    })).data;
}